import React, { Component, Fragment } from 'react';
import { includes, isEmpty } from 'lodash';
import TRP from '../../../components/Shared/TRP/TRP';
import './FundingOptions.scss';
import Case from '../../Shared/Switch/Case';
import Switch from '../../Shared/Switch/Switch';
import config from '../../../config/config';
import Phone from '../../Shared/Phone/Phone';
import {
  isAppBuy,
  isCollegeContribute,
  isIRAAutoMax,
  isRecurringBuy,
} from '../../../utils/transactions-util';
import warningExclamationBlue from '../../../assets/images/warning-exclamation-blue.svg';

export class FundingOptions extends Component {
  hasAddBank = () => {
    const { options } = this.props;
    return includes(options, 'addBank');
  };

  hasExisting = () => {
    const { options } = this.props;
    return includes(options, 'existing');
  };

  hasPersonalCheck = () => {
    const { options } = this.props;
    return includes(options, 'personalCheck');
  };

  hasMoreThanOneOption = () => {
    const { options } = this.props;
    if (!isEmpty(options)) {
      return options.length > 1;
    }
  };

  render() {
    const {
      isSalesforceRep,
      customerWebViewEnabled,
      stopTransfer,
      hasRasFundsOnly,
    } = this.props;

    const onlyOneOption = this.props.options.length < 2;
    return (
      <div>
        <Switch test={stopTransfer}>
          <Case value={true}>
            <div className="funding-options-block-container">
              <span>
                <img
                  alt="warning icon"
                  src={warningExclamationBlue}
                  className="hidden-xs funding-options-warning-icon"
                />
              </span>
              <span className="stop-transfer-block-warning funding-options-block-message">
                A block has been placed on adding new banks to this account.
                {!(!customerWebViewEnabled && isSalesforceRep) && (
                  <div>
                    Call <Phone phoneNumber="(877) 495-8459" /> to speak with an
                    associate.
                  </div>
                )}
              </span>
            </div>
          </Case>

          <Case value={false}>
            <div className="funding-options">
              <div style={{ fontFamily: 'Nimbus Sans Novus' }}>
                <span className="hidden-xs" style={{ fontWeight: 'bold' }}>
                  {!isRecurringBuy() &&
                    !isIRAAutoMax() &&
                    !hasRasFundsOnly &&
                    'Other funding options: '}
                </span>
                {this.hasAddBank() && (
                  <span>
                    <span className="hidden-xs" style={{ fontWeight: 'bold' }}>
                      {isRecurringBuy() || isIRAAutoMax()
                        ? 'Have a new bank account?'
                        : ''}{' '}
                    </span>
                    <a
                      id="add-new-bank-link"
                      href={`${config.url}/usis/transactions/addbank`}
                      className="underline text-nowrap e2e-add-bank-link college-branded-link"
                    >
                      Add another bank
                    </a>
                  </span>
                )}
              </div>
              {!hasRasFundsOnly &&
                !isRecurringBuy() &&
                !isIRAAutoMax() &&
                this.hasExisting() && (
                  <span>
                    {onlyOneOption ? (
                      isCollegeContribute() ||
                      (!customerWebViewEnabled && isSalesforceRep) ? (
                        ''
                      ) : (
                        <span>&nbsp; Move money from</span>
                      )
                    ) : (
                      <span>&nbsp;or</span>
                    )}
                    {isCollegeContribute() ? (
                      <span>
                        &nbsp;
                        <a
                          id="aa-exchange-link"
                          className="text-nowrap e2e-option-link college-branded-link"
                          href={`${config.url}/usis/transactions/college/exchange`}
                          style={{ textDecoration: 'underline' }}
                        >
                          {onlyOneOption ? 'E' : 'e'}xchange from an existing
                          portfolio
                        </a>
                      </span>
                    ) : (
                      <Fragment>
                        &nbsp;
                        <a
                          id="aa-exchange-link"
                          className="text-nowrap e2e-option-link"
                          href={`${config.url}/usis/transactions/exchange`}
                          style={{ textDecoration: 'underline' }}
                        >
                          {onlyOneOption ? 'an' : 'use an'} existing
                          {isAppBuy() ? ' investment' : ' fund'}
                        </a>{' '}
                        <span className="hidden-xs">
                          {' '}
                          at <TRP />
                        </span>
                      </Fragment>
                    )}
                  </span>
                )}
            </div>
          </Case>
        </Switch>
      </div>
    );
  }
}

FundingOptions.defaultProps = {
  actions: {},
  options: [],
  stopTransfer: false,
};

export default FundingOptions;
